function getSlideNumber(data, slideUuid) {
    if (slideUuid === undefined || slideUuid === null) return false;

    let slideNumber = false;
    const toNumber = Number(slideUuid);

    slideNumber = !isNaN(toNumber)
        ? toNumber - 1
        : slideNumber = data.slides.findIndex(s => s.uuid === slideUuid);

    if (!Number.isFinite(slideNumber) || slideNumber < 0 || slideNumber >= data.slides.length)
        slideNumber = false;

    return slideNumber;
}

export default getSlideNumber;
export { getSlideNumber };